//#region libraries
import React, { useEffect, useState } from 'react';
// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';

// custom components
import { Backbutton } from '_molecules';
import { WaitingTimesTable } from '_organisms';

// styling 
import { Colors } from '_styles';

// tremor
import { Flex } from '@tremor/react'

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectSelectedBeacon, selectWaitingTimes, selectBeaconWaitingTimes, deleteMinor } from '_redux/slices/beacons/beacons';
import { selectFirebaseInfo } from '_redux/slices/main-screen/user';

import { FaTrash } from 'react-icons/fa';
//#endregion

const BeaconDetails = (props) => {

    //#region local state

    // local states
    const [editing, setEditing] = useState(true);

    // beacon info
    const [description, setDescription] = useState('');
    const [major, setMajor] = useState('');
    const [minor, setMinor] = useState('');
    const [name, setName] = useState('');
    const [uuid, setUUUID] = useState('');
    //#endregion

    //#region redux
    const dispatch = useDispatch();
    // beacon redux
    const selectedBeaconId = useSelector(selectSelectedBeacon);
    const beaconList = useSelector(selectWaitingTimes);
    const beaconWaitTimes = useSelector(selectBeaconWaitingTimes);
    const dbUser = useSelector(selectFirebaseInfo);
    //#endregion

    useEffect(() => {
        if (beaconList != undefined && beaconList.length && beaconList.length > 0) {
            if (selectedBeaconId != undefined) {

                // set beacon details
                beaconList.forEach((beacon) => {
                    if (beacon.details.beaconId == selectedBeaconId) {
                        if (beacon.details.description) { setDescription(beacon.details.description) }
                        if (beacon.details.major) { setMajor(beacon.details.major) }
                        if (beacon.details.minor) { setMinor(beacon.details.minor) }
                        if (beacon.details.name) { setName(beacon.details.name) }
                        if (beacon.details.uuid) { setUUUID(beacon.details.uuid) }
                    }
                })

            }
        }
    }, [selectedBeaconId]);



    const deleteBeacon = () => {
        dispatch(deleteMinor({ beaconId: selectedBeaconId, iata: dbUser.details.authority }))
    }

    return (
        <Row className='mt-2' style={{ marginBottom: 200 }}>

            <Container>
                <Row>
                    <Flex>
                        <div style={{ justifyContent: 'flex-start', display: 'flex', }}>
                            <Backbutton onClick={props.close} />
                        </div>
                        <FaTrash onClick={deleteBeacon} color={Colors.PRM_LIGHT_BLUE} size={26} />
                    </Flex>
                    <Container>
                        <hr style={{ color: Colors.GRAY_LIGHT }} />
                    </Container>
                </Row>

                {/* Details */}
                <Row>
                    <Col>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Beacon ID</Form.Label>
                        <Form.Control type="text" placeholder="Beacon ID" value={selectedBeaconId} disabled={editing} />
                    </Col>
                    <Col>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Major</Form.Label>
                        <Form.Control type="text" placeholder="Beacon Major" value={major} disabled={editing} />
                    </Col>
                    <Col>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Minor</Form.Label>
                        <Form.Control type="text" placeholder="Beacon Minor" value={minor} disabled={editing} />
                    </Col>
                </Row>

                <Row className='mt-4'>
                    <Col xs={4}>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>UUID</Form.Label>
                        <Form.Control type="text" placeholder="Beacon UUID" value={uuid} disabled={editing} />
                    </Col>
                    <Col xs={4}>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Name</Form.Label>
                        <Form.Control type="text" placeholder="Beacon Name" value={name} disabled={editing} />
                    </Col>
                </Row>

                <Row className='mt-4'>
                    <Col xs={3}>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Description</Form.Label>
                        <Form.Control type="text" placeholder="Beacon Description" value={description} disabled={editing} />
                    </Col>
                </Row>
            </Container>

            <Row className='mt-4'>
                <WaitingTimesTable data={beaconWaitTimes} />
            </Row>

        </Row>
    );
};

export default BeaconDetails;
